module.exports = __webpack_public_path__ + "img/icon_auth@2x.f0f4c702.png";